<template>
  <q-btn
    v-if="isGranted('VIEW_USERS')"
    icon="fa fa-user"
    label="Users"
    title="Show Client Users"
    v-bind="$attrs"
    no-caps
    @click="openModal" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import isGranted from '@/auth/isGranted';
import { Client } from '@/type';
import openModal from '@/components/modal';
import ClientUsersModal from './ClientUsersModal.vue';

export default defineComponent({
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { client: _.cloneDeep(this.client) };
      openModal(ClientUsersModal, props);
    },
    isGranted,
  },
});
</script>
